import { Col } from "reactstrap";
import { CommentsTitle, Href } from "../../../Constants/Constants";
import { CommentsData } from "../../../Data/Blog/Blog";
import { dynamicImage, Image } from "../../../Utils";

const Comments = () => {
  return (
    <Col sm="12">
      <div className="blog-commant blog-card">
        <h3>{CommentsTitle}</h3>
        <ul className="comment-section">
          {CommentsData.map((item, index) => (
            <li className={item.class} key={index}>
              <div className="d-flex">
                <Image src={dynamicImage(`avtar/${item.image}.jpg`)} alt="Generic placeholder image" />
                <div className="flex-grow-1">
                  <h6>{"Josephin water "}</h6>
                  <span>{item.date}<a className="ps-2" href={Href}>{"reply"}</a></span>
                  <p>{"Donec rhoncus massa quis nibh imperdiet dictum. Vestibulum id est sit amet felis fringilla bibendum at at leo. Proin molestie ac nisi eu laoreet. Integer faucibus enim nec ullamcorper tempor. Aenean nec felis dui. Integer tristique odio mi, in volutpat metus posuere eu. Aenean suscipit ipsum nunc, id volutpat lorem hendrerit ac. Sed id elit quam. In ac mauris arcu."}</p>
                </div>
              </div>
              {item.class && (
                <ul>
                  <li className="replay">
                    <div className="d-flex">
                      <Image src={dynamicImage("avtar/4.jpg")} alt="Generic placeholder image" />
                      <div className="flex-grow-1">
                        <h6>{"Josephin water "}</h6>
                        <span>{"( 12 Jannuary 2024 at 1:30AM )"}<a className="ps-2" href={Href}>{"reply"}</a></span>
                        <p>{"Donec rhoncus massa quis nibh imperdiet dictum. Vestibulum id est sit amet felis fringilla bibendum at at leo. Proin molestie ac nisi eu laoreet. Integer faucibus enim nec ullamcorper tempor. Aenean nec felis dui. Integer tristique odio mi, in volutpat metus posuere eu. Aenean suscipit ipsum nunc, id volutpat lorem hendrerit ac. Sed id elit quam. In ac mauris arcu."}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </Col>
  );
};

export default Comments;
